module.exports = __webpack_public_path__ + "img/close.a62a66cc.svg";